<template>
  <div class="lock-warpper">
    <!--    <div class="container-img">-->
    <!--      <h1 class="websiteTitle" v-text="websiteTitle"></h1>-->
    <!--    </div>-->
    <!--      <div class="lock-img">-->
    <!--        <img src="../../assets/images/logo4.png" alt />-->
    <!--      </div>-->
    <div class="lock-container">
      <div class="lock-img-title">
        <img :src="userInfo.avatarText || defaultUserIcon" alt />
      </div>
      <el-form class="login-content">
        <el-form-item prop="password">
          <el-input v-model="password" placeholder="请输入密码" type="password">
            <el-button slot="prepend" icon="el-icon-lock"></el-button>
            <el-button slot="append" @click="onAlign()">忘记密码？</el-button>
          </el-input>
        </el-form-item>
        <el-form-item prop="imgCaptcha" class="input_code">
          <el-input v-model="imgCaptcha" size="large" type="text"  placeholder="请输入图形验证码"></el-input>
        </el-form-item>
        <el-form-item prop="imgCaptcha"  class="image_code">
          <el-image :src="getImgUrl" @click="handleChangeCheckCode"></el-image>
        </el-form-item>
        <div class="loginBtn">
          <el-button type="primary" @click="submitHandle()">解锁</el-button>
        </div>
      </el-form>
    </div>
    <div class="record_num" v-text="icp_number"></div>
  </div>
</template>

<script>
import util from "@/utils";
import { login, getDoctorInfo,randomImage } from "@/api/index.js";
export default {
  name: "",
  props: {},
  data() {
    return {
      defaultUserIcon: require("../../assets/images/defaultIcon.jpg"),
      password: "",
      imgCaptcha:'',
      userInfo: {},
      icp_number: util.icp_number,
      websiteTitle: util.copyrightName + util.WebsiteTitle,
      getImgUrl:'',
    };
  },
  created() {
    this.getDoctorInfo();
  },
  mounted() {
    this.handleChangeCheckCode()
  },
  activited() {},
  update() {},
  beforeRouteUpdate() {},
  methods: {
    go(url) {
      this.$router.push({
        path: url,
      });
    },
    onAlign() {
      const that = this;
      this.go("/forget");
    },
    /*
     * 提示信息
     * */
    elementTips: function (type, message) {
      const $t = "";
      this.$message({
        showClose: true,
        message: message,
        type: type,
      });
    },
    // 获取图形验证码
     async handleChangeCheckCode () {
      this.currdatetime = new Date().getTime();
      const res = await randomImage()
      // if(res.success) 
      console.log(res);
      this.getImgUrl = res.result
    },
    /**
     * 提交
     */
    submitHandle(userInfo) {
      const that = this;
      if (that.password === "") {
        that.elementTips("error", "请输入密码");
        return;
      }
      const params = {
        mobileOrName: util.getStore("user_mobile"),
        password: that.password,
        captcha : this.imgCaptcha
      };
      that.submit_status = true;
      login(params).then(that.loginHandle);
    },
    loginHandle(res) {
      const that = this;
      that.submit_status = false;
      if (res.success) {
        util.removeStore("lockState");
        that.elementTips("success", res.message);
        setTimeout(function () {
          that.go(util.getStore("lockPrePath"));
          util.removeStore("lockPrePath");
        }, 1500);
      } else {
        if (res.message === '验证码错误~') {
          this.handleChangeCheckCode()
        }
        that.elementTips("error", res.message);
      }
    },

    /**
     * 获取医生信息
     */
    getDoctorInfo() {
      const that = this;
      const params = {
        // "token": "8e5efaec789e8618402bafd1ce6dd22b"
         id: util.getStore("user_id"),
      };
      getDoctorInfo(params).then(that.readyInfo);
    },
    readyInfo(res) {
      const that = this;
      if (res.success) {
        that.userInfo = res.result;
        console.log(that.userInfo, "that.userInfo");
      } else {
        that.$message({
          showClose: true,
          message: res.message,
          type: "error",
        });
      }
    },
  },
  filter: {},
  computed: {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.lock-warpper {
  background-image: url("../../assets/images/login-bg2.jpg");
  width: 100%;
  height: 100%;
  position: relative;
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;

  .container-img {
    position: relative;
    top: 35%;
    left: 50%;
    background: rgba(255, 255, 255, 0.3);
    margin: -190px 0 0 -175px;
    width: 400px;
    height: 400px;
    overflow: hidden;
    border-radius: 15px;
    background-size: 100% 100%;
    .websiteTitle {
      width: 100%;
      text-align: center;
      line-height: 50px;
      font-size: 30px;
      // color: #fc701a;
      font-family: Noto Sans S Chinese;
      font-weight: bold;
    }
  }

  .lock-img {
    width: 50px;
    height: 80px;
    position: relative;
    top: 5%;
    left: 35%;
  }

  .lock-img img {
    width: 150px;
    height: 70px;
  }

  .lock-img-title {
    width: 80px;
    height: 80px;
    position: relative;
    top: 5%;
    left: 35%;
  }

  .lock-img-title img {
    width: 100%;
    height: 100%;
    // border: 1px #ccc solid;
    border-radius: 50%;

    -webkit-box-shadow: 0 8px 20px rgba(0, 0, 0, 0.6);
    -moz-box-shadow: 0 8px 20px rgba(0, 0, 0, 0.6);
    -o-box-shadow: 0 8px 20px rgba(0, 0, 0, 0.6);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.6);
  }

  .lock-container {
    position: relative;
    top: 55%;
    left: 50%;
    background: #ffffff;
    margin: -190px 0 0 -175px;
    width: 350px;
    overflow: hidden;
    border-radius: 15px;
    background-size: 100% 100%;
    box-shadow: 0 0 30px #ccc;

    .login-content {
      padding: 30px 30px;

      .loginBtn {
        text-align: center;

        button {
          width: 100%;
          height: 36px;
          margin-bottom: 10px;
        }
      }

      .tip {
        font-size: 14px;
        color: #ddd;
      }

      .footer {
        display: flex;
        justify-content: space-around;

        .align {
          font-size: 14px;
          // color: #606266;
          color: #23b0ef;
          cursor: pointer;
        }
      }
    }
  }
  .input_code {
    width: 60%;
    float: left;
  }

  .image_code {
    width: 35%;
    float: right;
  }

  .loginBtn {
    text-align: center;

    button {
      width: 100%;
      height: 36px;
      margin-bottom: 10px;
    }
  }
}
</style>
